import React, { useEffect, useState } from "react";
import "../../../index.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from 'moment';
import { Dialog } from "@progress/kendo-react-dialogs";


const QuickTransactionSaleInvoiceSection = (props) => {

    const [invoiceArray, setInvoiceArray] = useState([]);
    const [tempInvoice, setTempInvoice] = useState({ items: [] });
    const [selectedInvoice, setSelectedInvoice] = useState([]);
    const [changeQty, setChangeQty] = useState({ invoiceIndex: 0, itemIndex: 0, item: {} });
    const [selectedItem, setSelectedItem] = useState({ invoiceIndex: 0, itemIndex: 0, item: {} });
    const [totalAmount, setTotalAmount] = useState(0);
    const [businessSetting, setBusinessSetting] = useState({});
    const [transactionType, setTransactionType] = useState(props.transactionType);
    const [isEditMode, setIsEditMode] = useState(props.isEditMode);
    const [isMakePayment, setIsMakePayment] = useState(props.isMakePayment);
    const [isDuplicate, setIsDuplicate] = useState(props.isDuplicate);
    const [filterText, setFilterText] = useState('');
    const [isAddMoreItemDialog, setIsAddMoreItemDialog] = useState(false);

    useEffect(() => {
        let _UserSession = localStorage.getItem("vs_UserSession");
        if (_UserSession != undefined || _UserSession != null) {
            _UserSession = JSON.parse(_UserSession);
            setBusinessSetting(_UserSession.businessSetting);
        }
    }, []);

    useEffect(() => {
        setIsEditMode(props.isEditMode);
    }, [props.isEditMode]);

    useEffect(() => {
        setIsDuplicate(props.isDuplicate);
    }, [props.isDuplicate]);

    useEffect(() => {
        let invoices = props.invoiceArray;

        invoices.sort(function (a, b) {
            var c = new Date(a.invoiceDate + ' ' + a.invoiceTime);
            var d = new Date(b.invoiceDate + ' ' + b.invoiceTime);
            return d - c;
        });
        ;
        setInvoiceArray(invoices);

    }, [props.invoiceArray])

    useEffect(() => {
        let invoiceData = props.selectedInvoice;

        if (invoiceData.length > 0) {
            setSelectedInvoice(invoiceData);
            setTotalAmount(invoiceData[0].totalSummary.subtotal);
        }
    }, [props.selectedInvoice])



    const updateItemView = (invoice) => {
        let newInvoiceItem = { ...invoice };
        newInvoiceItem.items = newInvoiceItem.items.map((item) => {
            let newQuantity = item.quantity;
            return ({
                ...item,
                newQuantity: newQuantity,
            })
        });
        return newInvoiceItem
    }

    const invoiceItemSave = () => {
        if (tempInvoice.items.filter((item) => item.isSelect).length > 0) {
            let data = invoiceArray.map((item, itemIndex) => ({
                ...item,
                isSelect: tempInvoice.invoice_no == item.invoice_no ? true : item.isSelect,
                items: tempInvoice.invoice_no == item.invoice_no ? tempInvoice.items : item.items
            }))
            setInvoiceArray(data);
            let remainingSelectedInvoice = data.filter((data) => data.isSelect);
            setSelectedInvoice(remainingSelectedInvoice);
            setTempInvoice({ items: [] });
            let totalAmount = 0;

            remainingSelectedInvoice.map((data) => {
                let items = data.items.filter((item) => item.isSelect).map((item) => {
                    let price = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
                    let sub_total_amount = (item.newQuantity * price);
                    sub_total_amount = sub_total_amount - (transactionType == 3 ? item.discount_in_amount : 0)
                    let taxValue = (parseInt(item.tax_type.ratio) * sub_total_amount) / 100;
                    console.log('sub_total_amount', sub_total_amount);
                    let total_amount = sub_total_amount + item.Additional_CESS + taxValue;
                    console.log('sub_total_amount', total_amount);
                    total_amount = parseFloat(total_amount.toFixed(2));
                    totalAmount += total_amount;
                    return ({
                        ...item,
                        subtotal: total_amount
                    })
                })
                return ({
                    ...data,
                    items: items
                })
            })

            setTotalAmount(totalAmount);
            props.callBackItem(remainingSelectedInvoice, totalAmount);
        } else {
            alert('Please select at least one item!');
        }
    }
    const getPriceWithTaxWithOutTax = (sale_tax_type, ratio, price) => {
        if (sale_tax_type == 'With Tax') {
            price = (price / (100 + ratio)) * 100;
        }
        return price;
    }
    // Qty is editable for a normal item without free qty on a fresh Purchase
    // Return, and on a Sale Return that is fresh or converted from a sale
    // (isEditMode is also true on convert, so the form passes isConvert).
    // Editing a saved return, duplicate and paid returns stay read-only, and
    // Delivery Challan keeps its old behaviour.
    const canChangeQty = (item) => {
        const isSaleReturnConvert = transactionType == 1 && props.isConvert === true;
        let isOpenReturn = false;
        if (transactionType == 2) {
            isOpenReturn = !isEditMode;
        } else if (transactionType == 1) {
            isOpenReturn = !isEditMode || isSaleReturnConvert;
        }
        // On convert, isMakePayment says the sale has payments, not that
        // this new return has been paid, so it doesn't lock the qty.
        const isPaidReturn = isMakePayment && !isSaleReturnConvert;
        return isOpenReturn && !isDuplicate && !isPaidReturn &&
            !(parseFloat(item && item.free_quantity) > 0);
    }

    // Highest qty that can be returned for an item: the still-returnable qty
    // when the form sends it (Sale Return convert), else the line's quantity.
    const getMaxReturnQty = (item) => {
        return (item && item.maxReturnQuantity !== undefined)
            ? parseFloat(item.maxReturnQuantity)
            : parseFloat(item && item.quantity);
    }

    const saveChangeQty = () => {
        let enteredQty = String(changeQty.item.newQuantity).trim();
        if (!/^\d+$/.test(enteredQty)) {
            alert('Please enter a valid whole number quantity!');
            return;
        }
        if (parseInt(enteredQty) > 0) {
            let bb = [...selectedInvoice];
            let item = { ...changeQty.item, newQuantity: parseInt(enteredQty) };

            const maxReturnQty = getMaxReturnQty(item);
            if (maxReturnQty < item.newQuantity) {
                alert('can\'t be greater then ' + maxReturnQty + ' Qty')
                return;
            }
            let itemPrice = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
            let itemSubTotal = item.newQuantity * itemPrice;
            let itemTaxValue = (parseInt(item.tax_type.ratio || 0) * itemSubTotal) / 100;
            item.subtotal = parseFloat(itemSubTotal.toFixed(2));
            item.tax_value = parseFloat(itemTaxValue.toFixed(2));
            item.total_amount = parseFloat((itemSubTotal + parseFloat(item.Additional_CESS || 0) + itemTaxValue).toFixed(2));
            bb = bb.map((invoice) => ({
                ...invoice,
                items: invoice.items.map((oldItem) => oldItem.inv_item_id == item.inv_item_id ? item : oldItem)
            }))
            //bb[changeQty.invoiceIndex].items[changeQty.itemIndex] = item;
            setSelectedInvoice(bb);
            //setInvoiceArray(bb);
            let totalAmount = 0;
            bb.map((data) => {
                let items = data.items.filter((item) => item.isSelect).map((item) => {
                    let price = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
                    let sub_total_amount = (item.newQuantity * price);
                    sub_total_amount = sub_total_amount - (transactionType == 3 ? item.discount_in_amount : 0)
                    let taxValue = (parseInt(item.tax_type.ratio) * sub_total_amount) / 100;
                    console.log('sub_total_amount', sub_total_amount);
                    let total_amount = sub_total_amount + item.Additional_CESS + taxValue ;
                    console.log('sub_total_amount', total_amount);
                    total_amount = parseFloat(total_amount.toFixed(2));
                    totalAmount += total_amount;

                    return ({
                        ...item,
                        subtotal: total_amount
                    })
                })
                return ({
                    ...data,
                    items: items
                })
            })
            setTotalAmount(totalAmount);
            props.callBackItem(bb, totalAmount);
        } else {
            alert('Please enter some quantity!');
        }

    }
    const saveChangeSerialQty = () => {
        let bb = [...selectedInvoice];
        console.log('bb', JSON.stringify(bb));
        let item = { ...selectedItem.item };
        let qty = item.selectedData.filter((data) => data.isSelected && !data.isFreeQuantity).length;
        item.newQuantity = qty;
        console.log('qty', JSON.stringify(qty));
        let price = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
        let sub_total_amount = (item.newQuantity * price);
        sub_total_amount = sub_total_amount - (transactionType == 3 ? item.discount_in_amount : 0)
        let taxValue = (parseInt(item.tax_type.ratio) * sub_total_amount) / 100;
        let total_amount = sub_total_amount + item.Additional_CESS + taxValue ;
        total_amount = parseFloat(total_amount.toFixed(2));

        item.total_amount = total_amount;



        bb = bb.map((invoice) => ({
            ...invoice,
            items: invoice.items.map((oldItem) => oldItem.inv_item_id == item.inv_item_id ? item : oldItem)
        }))
        //bb[selectedItem.invoiceIndex].items[selectedItem.itemIndex] = item;
        console.log('bb', JSON.stringify(bb));
        setSelectedInvoice(bb);
        //setInvoiceArray(bb);
        let totalAmount = 0;
        bb.map((data) => {
            let items = data.items.filter((item) => item.isSelect).map((item) => {
                let price = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
                let sub_total_amount = (item.newQuantity * price);
                sub_total_amount = sub_total_amount - (transactionType == 3 ? item.discount_in_amount : 0)
                let taxValue = (parseInt(item.tax_type.ratio) * sub_total_amount) / 100;
                let total_amount = sub_total_amount + item.Additional_CESS + taxValue ;
                total_amount = parseFloat(total_amount.toFixed(2));
                totalAmount += total_amount;
                return ({
                    ...item,
                    subtotal: total_amount
                })
            })
            return ({
                ...data,
                items: items
            })
        })
        setTotalAmount(totalAmount);

        props.callBackItem(bb, totalAmount);

    }
    const deleteItem = (mainIndex, itemIndex, inv_item_id) => {
        let _selectedInvoice = [...selectedInvoice];
        let invoiceItem = _selectedInvoice[0].items.map((data, index) => ({
            ...data,
            isSelect: data.inv_item_id == inv_item_id ? false : data.isSelect
        }));

        _selectedInvoice = _selectedInvoice.map((invoice) => ({
            ...invoice,
            items: invoiceItem
        }))

        const selectedItems = _selectedInvoice.flatMap(invoice =>
            invoice.items.filter(item => item.isSelect)
        );

        if (selectedItems.length == 0) {
            _selectedInvoice = [];
        }
        setSelectedInvoice(_selectedInvoice);

        let invoiceData = invoiceArray.map((item, _mainIndex) => ({
            ...item,
            items: item.items.map((data, index) => {
                return ({
                    ...data,
                    isSelect: data.inv_item_id == inv_item_id ? false : data.isSelect,
                    selectedData: data.inv_item_id == inv_item_id ? data.selectedData.map((serial) => ({
                        ...serial,
                        isSelected: true
                    })) : data.selectedData
                })
            })
        }));
        invoiceData = invoiceData.map((item) => ({
            ...item,
            isSelect: item.items.filter((data) => data.isSelect).length > 0,
        }));
        setInvoiceArray(invoiceData);
        let totalAmount = 0;
        _selectedInvoice.map((data) => {
            data.items.filter((item) => item.isSelect).map((item) => {
                let price = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
                let sub_total_amount = (item.newQuantity * price);
                sub_total_amount = sub_total_amount - (transactionType == 3 ? item.discount_in_amount : 0)
                let taxValue = (parseInt(item.tax_type.ratio) * sub_total_amount) / 100;
                let total_amount = sub_total_amount + item.Additional_CESS + taxValue;
                total_amount = parseFloat(total_amount.toFixed(2));
                totalAmount += total_amount;
            })
        })
        setTotalAmount(totalAmount);
        props.callBackItem(_selectedInvoice, totalAmount);
    }

    const isAdditionalCess = () => {
        let isAdditionalCess = false;
        selectedInvoice.length > 0 && selectedInvoice.map((data, index) => {
            data.items.filter((item) => item.isSelect).map((item, itemIndex) => {
                if (item.Additional_CESS > 0) {
                    isAdditionalCess = true;
                }
            });
        });
        return isAdditionalCess;
    }

    const getFilterInvoice = () => {
        let data = invoiceArray.filter((item) => String(item.invoice_no).includes(filterText) ||
            String((item.totalSummary.reverseChargeStatus == 1 ? item.totalSummary.payableAmount : item.totalSummary.totalAmount)).includes(filterText));

        data.sort((a, b) => b.added_on - a.added_on);

        return data;
    }

    const dynamicInputFiled = () => {
        return selectedInvoice.length > 0 && selectedInvoice.map((data, index) => {
            let isPaidOrReceive;
            return data.items.filter((item) => item.isSelect).map((item, itemIndex) => {
                let price = getPriceWithTaxWithOutTax(item.sale_tax_type, parseInt(item.tax_type.ratio), item.rate);
                console.log('item.sale_tax_type', item.sale_tax_type);
                let sub_total_amount = (item.newQuantity * price);
                sub_total_amount = sub_total_amount - (transactionType == 3 ? item.discount_in_amount : 0)
                let taxValue = (parseInt(item.tax_type.ratio) * sub_total_amount) / 100;
                console.log('taxValue', taxValue);
                console.log('item.Additional_CESS', item.Additional_CESS);
                let total_amount = sub_total_amount + item.Additional_CESS + taxValue;
                let subTotal = parseFloat(total_amount.toFixed(2));

                return (
                    <tr key={itemIndex}>
                        {
                            (!isDuplicate && !isEditMode) &&
                            <td>
                                <button
                                    type="button"
                                    onClick={() => {
                                        deleteItem(index, itemIndex, item.inv_item_id)
                                    }}
                                    className="btn btn-outline-danger"
                                >
                                    X
                                </button>
                            </td>
                        }

                        <td>{itemIndex + 1}</td>
                        <td>
                            <div className="col-lg-12 form-material" id="paddingOff">
                                <span>{(data.prefix.id > 0 && data.prefix.name) && "(" + data.prefix.name + ")"}{item.invoice_no}</span>
                            </div>
                        </td>

                        <td>
                            <div className="col-lg-12 form-material" id="paddingOff">
                                <span>{item.name}</span>
                            </div>
                        </td>
                        {
                            isAdditionalCess() &&
                            <td>
                                <div className="col-lg-12 form-material" id="paddingOff">
                                    <span>{item.Additional_CESS}</span>
                                </div>
                            </td>
                        }

                        <td>
                            <div className="col-lg-12 form-material" id="paddingOff">
                                <span style={{ marginRight: 10 }}>{item.free_quantity > 0 && '(' + item.free_quantity + ' Free)'} {item.newQuantity} {item.unit.slug} X {parseFloat(item.rate || 0).toFixed(2)}</span>
                                {
                                    (item.trackingType == 'Serial' && item.selectedData && item.selectedData.length > 0) ?
                                        <button type="button" className="btn btn-outline-danger"
                                            data-toggle="modal"
                                            data-target="#viewSerialModal" onClick={() => {
                                                let aa = { ...item };
                                                setSelectedItem({ invoiceIndex: index, itemIndex: itemIndex, item: aa })
                                            }}>
                                            <span>View Serial</span>
                                        </button> :
                                        (
                                            (item.trackingType == 'Batch' && item.selectedData && item.selectedData.length > 0) ?
                                                <button type="button" className="btn btn-outline-danger"
                                                    data-toggle="modal"
                                                    data-target="#viewBatchModal" onClick={() => {
                                                        let aa = { ...item };
                                                        setSelectedItem({ invoiceIndex: index, itemIndex: itemIndex, item: aa })
                                                    }}>
                                                    <span>View Batch</span>
                                                </button> :
                                                <button type="button" className="btn btn-outline-danger"
                                                    data-toggle="modal"
                                                    data-target="#changeQtyModal" onClick={() => {
                                                        let aa = { ...item };
                                                        setChangeQty({ invoiceIndex: index, itemIndex: itemIndex, item: aa })
                                                    }}>
                                                    {/* <span>{(isDuplicate || isMakePayment) ? "View" : "ChaViewnge"} QTY</span> */}
                                                    <span>View Normal</span>
                                                </button>
                                        )
                                }
                            </div>
                        </td>
                        {
                            transactionType == 3 &&
                            <td>
                                <div className="col-lg-12 form-material" id="paddingOff">
                                    <span>{item.discount_in_per}%</span>
                                </div>
                            </td>
                        }
                        <td>
                            <div className="col-lg-12 form-material" id="paddingOff">
                                <span>{item.tax_type.ratio ? (item.tax_type.ratio + "%(" + item.sale_tax_type + ")") : 0}</span>
                            </div>
                        </td>

                        <td>
                            <div className="col-lg-12 form-material" id="paddingOff">
                                <span>{subTotal}</span>
                            </div>
                        </td>
                    </tr>
                )
            })
        })
    }

    return (
        <div className="block">
            <div className="row">
                <div className="col-md-12" id="formSideItem">
                    <div className="block block-transparent">
                        <div className="block-content" id="formSideItem">
                            <table className="table table-bordered table-striped table-vcenter">
                                <thead id="sideTable">
                                    <tr>
                                        {
                                            (!isDuplicate && !isEditMode) &&
                                            <th style={{ width: "30px" }}></th>
                                        }
                                        <th style={{ width: "30px" }}>#</th>
                                        <th style={{ width: "130px" }}>{(transactionType == 1 || transactionType == 3) ? "Invoice No" : "Bill No"}</th>
                                        <th style={{ width: "130px" }}>Item Name</th>
                                        {
                                            isAdditionalCess() &&
                                            <th style={{ width: "200px" }}>Additional CESS</th>
                                        }
                                        <th style={{ width: "200px" }}>Quantity</th>
                                        {
                                            transactionType == 3 &&
                                            <th style={{ width: "200px" }}>Discount %</th>
                                        }
                                        <th style={{ width: "80px" }}>Tax %</th>
                                        <th style={{ width: "100px" }}>Subtotal</th>
                                    </tr>
                                </thead>

                                <tbody id="sideTable">
                                    {dynamicInputFiled()}
                                    <tr>
                                        {
                                            (!isDuplicate && !isEditMode) &&
                                            <td></td>
                                        }
                                        <td></td>
                                        <td></td>
                                        {
                                            isAdditionalCess() &&
                                            <td></td>
                                        }
                                        <td>
                                            <span><b>Total</b></span>
                                        </td>

                                        {
                                            transactionType == 3 &&
                                            <td></td>
                                        }
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <span><b>{totalAmount}</b></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>


                            <div>
                                {
                                    (!isDuplicate && selectedInvoice.length == 0) &&
                                    <button type="button" className="btn btn-primary" data-toggle="modal"
                                        data-target="#invoiceModal">
                                        {(transactionType == 1 || transactionType == 3) ? "Add Invoice" : "Add Bill"}
                                    </button>
                                }
                                {
                                    (selectedInvoice.length > 0 && selectedInvoice.some(invoice => invoice.items.some(item => !item.isSelect))) &&
                                    <button type="button" className="btn btn-primary"
                                        onClick={() => {

                                            let newInvoiceItem = selectedInvoice[0];
                                            if (transactionType == 1 || transactionType == 2) {
                                                if (parseInt(newInvoiceItem.totalTransDiscountAmount) > 0) {
                                                    if (transactionType == 1) {
                                                        alert('You can\'t create a sales return for this sales invoice as there is a discount given. To create a sales return please go to the sales invoices section and remove the discount from this sales invoice. Thanks');
                                                    } else {
                                                        alert('You can\'t create a purchase return for this purchase bill as there is a discount given. To create a purchase return please go to the purchase bill section and remove the discount from this purchase bill. Thanks');
                                                    }

                                                    return;
                                                }
                                            }
                                            console.log('add change invoice', JSON.stringify(newInvoiceItem))
                                            setTempInvoice(newInvoiceItem);
                                            setIsAddMoreItemDialog(true);
                                        }}>
                                        {"Add/Change Item"}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*Select invoice dialog start*/}
            <div className="modal fade" id="invoiceModal" tabIndex="-1" role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable" role="document" style={{ maxWidth: '45%' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {(transactionType == 1 || transactionType == 3) ? "Select Invoice" : "Select Bill"}</h5>
                            <button type="button" className="close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div style={{ marginLeft: 20, marginRight: 20 }}>
                            <input
                                type="text"
                                className="form-control search-box"
                                onChange={(e) => {
                                    let value = e.currentTarget.value;
                                    setFilterText(value)
                                }}
                                placeholder={"Search by " + ((transactionType == 1 || transactionType == 3) ? "Invoice No." : "Bill No.") + " or total amount"}
                                autoComplete="off"
                                value={filterText}
                            />
                        </div>
                        <div className="modal-body">
                            <div className="list-group">
                                {

                                    getFilterInvoice().map((data, index) => {

                                        return (
                                            <button key={index} type="button" onClick={() => {
                                                let newInvoiceItem = updateItemView(data);
                                                if (transactionType == 1 || transactionType == 2) {
                                                    if (parseInt(newInvoiceItem.totalTransDiscountAmount) > 0) {
                                                        if (transactionType == 1) {
                                                            alert('You can\'t create a sales return for this sales invoice as there is a discount given. To create a sales return please go to the sales invoices section and remove the discount from this sales invoice. Thanks');
                                                        } else {
                                                            alert('You can\'t create a purchase return for this purchase bill as there is a discount given. To create a purchase return please go to the purchase bill section and remove the discount from this purchase bill. Thanks');
                                                        }

                                                        return;
                                                    }
                                                }
                                                setTempInvoice(newInvoiceItem);
                                            }} data-toggle="modal" data-dismiss="modal" data-target={(transactionType != 3 && parseInt(data.totalTransDiscountAmount) > 0) ? '' : "#invoiceItemModal"}
                                                className={"list-group-item list-group-item-action " + (data.isSelect ? 'active' : '')}>

                                                <div className="row">
                                                    <div className="col-4">
                                                        <span>{(transactionType == 1 || transactionType == 3) ? "Invoice No" : "Bill No"}</span><br />
                                                        <span>{(data.prefix.id > 0 && data.prefix.name) &&
                                                            "(" + data.prefix.name + ")"
                                                        }{data.invoice_no}</span>
                                                    </div>
                                                    <div className="col-4">
                                                        <span >{(transactionType == 1 || transactionType == 3) ? "Invoice Date" : "Bill Date"}</span><br />
                                                        <span >{data.invoiceDate} {businessSetting.Tran_AddTime != 0 && data.invoiceTime}</span>
                                                    </div>
                                                    <div className="col-4">
                                                        <span >Status</span><br />
                                                        <span className={data.payment_paid == 'UNPAID' ? "badge badge-warning" : (data.payment_paid == 'PAID' ? "badge badge-success" : "badge badge-info")}>{data.payment_paid}</span>
                                                    </div>
                                                </div>
                                                <div className="row" style={{ marginTop: 20 }}>
                                                    <div className="col-4">
                                                        <span>Total Amount</span><br />
                                                        <span>{data.totalSummary.reverseChargeStatus == 1 ? data.totalSummary.payableAmount : data.totalSummary.totalAmount}</span>
                                                    </div>
                                                    <div className="col-4">
                                                        <span>Balance Amount</span><br />
                                                        <span>{data.totalSummary.dueAmount}</span>
                                                    </div>
                                                    <div className="col-4">
                                                        <span>Total Item</span><br />
                                                        <span>{data.items.length}</span>
                                                    </div>
                                                </div>
                                                {index != invoiceArray.length - 1 && <div style={{ borderBottom: "1px solid #e4e7ed", marginTop: 10 }}></div>}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary"
                                data-dismiss="modal">Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/*Select invoice dialog end*/}
            {/*Select invoice item dialog start*/}
            <div className="modal fade" id="invoiceItemModal" tabIndex="-2" role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable" role="document" style={{ maxWidth: '45%' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {(transactionType == 1 || transactionType == 3) ? "Invoice Items Details" : "Bill Items Details"}</h5>
                            <button type="button" className="close" data-dismiss="modal"
                                data-toggle="modal" data-target="#invoiceModal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                            <span >
                                {(transactionType == 1 || transactionType == 3) ? "Invoice No" : "Bill No"}: {tempInvoice.prefix && ((tempInvoice.prefix.id > 0 & tempInvoice.prefix.name) ? "(" + tempInvoice.prefix.name + ")" : '')} {tempInvoice.invoice_no}</span>
                        </div>
                        <div className="modal-body">
                            <div className="list-group">
                                {
                                    tempInvoice.items && tempInvoice.items.map((data, index) => {
                                        return (
                                            <button key={index} type={'button'} onClick={() => {
                                                let _tempInvoice = { ...tempInvoice };
                                                //if(_tempInvoice.items.filter((item) => parseInt(item.discount_in_amount) > 0).length > 0){
                                                if (transactionType == 1 || transactionType == 2) {
                                                    if (parseFloat(data.discount_in_amount) > 0) {
                                                        if (transactionType == 1) {
                                                            alert('You can\'t create a sales return for this sales invoice as there is a discount given. To create a sales return please go to the sales invoices section and remove the discount from this sales invoice. Thanks');
                                                        } else {
                                                            alert('You can\'t create a purchase return for this purchase bill as there is a discount given. To create a purchase return please go to the purchase bill section and remove the discount from this purchase bill. Thanks');
                                                        }
                                                        return;
                                                    }
                                                }
                                                _tempInvoice.items = _tempInvoice.items.map((data, dataIndex) => ({
                                                    ...data,
                                                    isSelect: index == dataIndex ? !data.isSelect : data.isSelect
                                                }));
                                                setTempInvoice(_tempInvoice);
                                            }} className={"list-group-item list-group-item-action " + (data.isSelect ? 'active' : '')}>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span><b>{index + 1}. {data.name}</b></span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.total_amount}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span>Item Subtotal</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.newQuantity} {data.unit.slug} X {parseFloat(data.rate || 0).toFixed(2)} = {parseFloat(data.rate || 0) * data.newQuantity}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span>Discount %</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.discount_in_per ? parseFloat(data.discount_in_per).toFixed(2) : 0.0}%</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span>Tax % {data.tax_type.name == 'None' ? '' : data.tax_type.name}</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.tax_type.ratio ? data.tax_type.ratio : 0.0}%</span>
                                                    </div>
                                                </div>

                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary"
                                data-dismiss="modal" data-toggle="modal"
                                data-target="#invoiceModal">Close
                            </button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => invoiceItemSave()}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
            {/*Select invoice item dialog end*/}
            {/*Change Quantity dialog start*/}
            <div className="modal fade" id="changeQtyModal" tabIndex="-1" role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document" style={{ maxWidth: '45%' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {/* {(isDuplicate || isMakePayment) ? 'View' : 'Change'} Quantity */}
                                {canChangeQty(changeQty.item) ? 'Change' : 'View'} Quantity
                            </h5>
                            <button type="button" className="close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="list-group">
                                <input
                                    // type="text"
                                    className="form-control search-box"
                                    onChange={(e) => {
                                        let aa = { ...changeQty };
                                        aa.item.newQuantity = e.target.value;
                                        setChangeQty(aa);
                                    }}
                                    type="number"
                                    placeholder="Change Quantity...."
                                    autoComplete="off"
                                    name="quantity"
                                    id={"quantity"}
                                    // readOnly={isDuplicate || isMakePayment}
                                    readOnly={!canChangeQty(changeQty.item)}
                                    min="1"
                                    step="1"
                                    max={getMaxReturnQty(changeQty.item)}
                                    value={changeQty.item.newQuantity}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary"
                                data-dismiss="modal" data-toggle="modal"
                                data-target="#changeQtyModal">Close
                            </button>
                            {/* {
                                (!isDuplicate && !isMakePayment) &&
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => saveChangeQty()}>Save</button>
                            } */}
                            {
                                canChangeQty(changeQty.item) &&
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => saveChangeQty()}>Save</button>
                            }

                        </div>
                    </div>
                </div>
            </div>
            {/*Select Quantity dialog end*/}
            {/*Select view serial dialog end*/}
            <div className="modal fade" id="viewSerialModal" tabIndex="-1" role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document" style={{ maxWidth: '35%' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Serial Details</h5>
                            <button type="button" className="close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {
                                selectedItem.item.name &&
                                <div className="list-group">
                                    <h3 className="list-group-item list-group-item-action active">{selectedItem.item.name}</h3>
                                    {
                                        selectedItem.item.selectedData.map((data, index) => {
                                            return (
                                                <div key={index} className={"list-group-item " + (!data.isSelected ? "list-group-item-dark" : "")} style={{ border: '2px solid #e4e7ed' }}>
                                                    {
                                                        data.isFreeQuantity &&
                                                        <div className="">
                                                            <span style={{ color: 'green', fontSize: 20 }}>FREE</span>
                                                        </div>
                                                    }
                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>{businessSetting.SerialNoTxt} : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.serial_no}</span>
                                                        </div>
                                                    </div>
                                                    {
                                                        businessSetting.SerialNoAdditionalChk1 == 1 &&
                                                        <div className="form-group row">
                                                            <div className="col-6">
                                                                <span>{businessSetting.SerialNoAdditionalLabel1} : </span>
                                                            </div>
                                                            <div className="col-6">
                                                                <span>{data.serialNoAdditionalValue1 ? data.serialNoAdditionalValue1 : 'NA'}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        businessSetting.SerialNoAdditionalChk2 == 1 &&
                                                        <div className="form-group row">
                                                            <div className="col-6">
                                                                <span>{businessSetting.SerialNoAdditionalLabel2} : </span>
                                                            </div>
                                                            <div className="col-6">
                                                                <span>{data.serialNoAdditionalValue2 ? data.serialNoAdditionalValue2 : 'NA'}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="form-group row">
                                                        <div className="col-6">

                                                        </div>
                                                        <div className="col-6">
                                                            {
                                                                data.isSoldOut ?
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-secondary"
                                                                >
                                                                    Sold Out
                                                                </button> :
                                                                (!isDuplicate && (
                                                                    data.isSelected ?
                                                                    ((selectedItem.item.selectedData.filter((d) => d.isSelected && !d.isFreeQuantity).length > 1 || data.isFreeQuantity) &&
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            let serialData = selectedItem.item.selectedData.map((d, itemIndex) => ({
                                                                                ...d,
                                                                                isSelected: index == itemIndex ? false : d.isSelected
                                                                            }));
                                                                            let _selectedItem = { ...selectedItem };
                                                                            _selectedItem.item.selectedData = serialData;
                                                                            setSelectedItem(_selectedItem);
                                                                        }}
                                                                        className="btn btn-outline-danger"
                                                                    >
                                                                        Remove
                                                                    </button>) :
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            let serialData = selectedItem.item.selectedData.map((d, itemIndex) => ({
                                                                                ...d,
                                                                                isSelected: index == itemIndex ? true : d.isSelected
                                                                            }));
                                                                            let _selectedItem = { ...selectedItem };
                                                                            _selectedItem.item.selectedData = serialData;
                                                                            setSelectedItem(_selectedItem);
                                                                        }}
                                                                        className="btn btn-outline-danger"
                                                                    >
                                                                        Undo
                                                                    </button>
                                                                ))
                                                            }

                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary"
                                data-dismiss="modal">Close
                            </button>
                            {
                                !isDuplicate &&
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => saveChangeSerialQty()}>Save</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {/*Select view serial dialog end*/}
            {/*Select view batch dialog end*/}
            <div className="modal fade" id="viewBatchModal" tabIndex="-1" role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document" style={{ maxWidth: '35%' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Batch Details</h5>
                            <button type="button" className="close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            {
                                selectedItem.item.name &&
                                <div className="list-group">
                                    <h3 className="list-group-item list-group-item-action active">{selectedItem.item.name}</h3>
                                    {
                                        selectedItem.item.selectedData.map((data, index) => {
                                            return (
                                                <div key={index} className={"list-group-item"} style={{ border: '2px solid #e4e7ed' }}>
                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>{businessSetting.BatchNoTxt} : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.batch_no}</span>
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>{businessSetting.ModelNoTxt} : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.model_no ? data.model_no : 'NA'}</span>
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>{businessSetting.SizeTxt} : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.size ? data.size : 0}</span>
                                                        </div>
                                                    </div>

                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>{businessSetting.MfgDateTxt} : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.mfg_date}</span>
                                                        </div>
                                                    </div>

                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>{businessSetting.ExpDateTxt} : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.exp_date}</span>
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>{businessSetting.BatchNoAdditionalLabel1 ? businessSetting.BatchNoAdditionalLabel1 : 'N/A'} : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.batchNoAdditionalValue1 ? data.batchNoAdditionalValue1 : 'NA'}</span>
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-6">
                                                            <span>Quantity : </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span>{data.used_stock}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary"
                                data-dismiss="modal">Close
                            </button>
                            {/*<button type="button" className="btn btn-primary"  data-dismiss="modal" onClick={() => saveChangeBatchQty()}>Save</button>*/}
                        </div>
                    </div>
                </div>
            </div>
            {/*Select view batch dialog end*/}
            {isAddMoreItemDialog && (
                <Dialog width={800} title={'Invoice Items Details'} onClose={() => setIsAddMoreItemDialog(false)}>
                    <div className="modal-content">

                        <span className="modal-title" id="exampleModalLabel">
                            {(transactionType == 1 || transactionType == 3) ? "Invoice No" : "Bill No"}: {tempInvoice.prefix && ((tempInvoice.prefix.id > 0 && tempInvoice.prefix.name) ? "(" + tempInvoice.prefix.name + ")" : '')} {tempInvoice.invoice_no}</span>
                        <div className="modal-body">
                            <div className="list-group">
                                {
                                    tempInvoice.items && tempInvoice.items.map((data, index) => {
                                        return (
                                            <button key={index} type={'button'} onClick={() => {
                                                let _tempInvoice = { ...tempInvoice };
                                                if (transactionType == 1 || transactionType == 2) {
                                                    if (parseFloat(data.discount_in_amount) > 0) {
                                                        if (transactionType == 1) {
                                                            alert('You can\'t create a sales return for this sales invoice as there is a discount given. To create a sales return please go to the sales invoices section and remove the discount from this sales invoice. Thanks');
                                                        } else {
                                                            alert('You can\'t create a purchase return for this purchase bill as there is a discount given. To create a purchase return please go to the purchase bill section and remove the discount from this purchase bill. Thanks');
                                                        }
                                                        return;
                                                    }
                                                }
                                                _tempInvoice.items = _tempInvoice.items.map((data, dataIndex) => ({
                                                    ...data,
                                                    isSelect: index == dataIndex ? !data.isSelect : data.isSelect
                                                }));
                                                setTempInvoice(_tempInvoice);
                                            }} className={"list-group-item list-group-item-action " + (data.isSelect ? 'active' : '')}>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span><b>{index + 1}. {data.name}</b></span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.total_amount}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span>Item Subtotal</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.newQuantity} {data.unit.slug} X {parseFloat(data.rate || 0).toFixed(2)} = {parseFloat(data.rate || 0) * data.newQuantity}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span>Discount %</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.discount_in_per ? parseFloat(data.discount_in_per).toFixed(2) : 0.0}%</span>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-6">
                                                        <span>Tax % {data.tax_type.name == 'None' ? '' : data.tax_type.name}</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span>{data.tax_type.ratio ? data.tax_type.ratio : 0.0}%</span>
                                                    </div>
                                                </div>

                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary"
                                onClick={() => { setIsAddMoreItemDialog(false) }}>Close
                            </button>
                            <button type="button" className="btn btn-primary"
                                onClick={() => {
                                    invoiceItemSave();
                                    setIsAddMoreItemDialog(false);
                                }}>Save</button>
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
}
export default QuickTransactionSaleInvoiceSection
